__webpack_require__.p = "/diyars-book-reviews/";